import React from 'react'
import { ESTADOS } from './rotaHelpers'

export default function RotasReportFilters({ fiscals = [], filters, onChange, onSubmit }) {
  return (
    <div className="rota-surface rota-section-card mb-4">
      <div className="d-flex flex-wrap justify-content-between align-items-center mb-3">
        <div>
          <p className="rota-eyebrow mb-1">Relatório consolidado</p>
          <h3 className="rota-section-title mb-0">Filtros de análise</h3>
        </div>
        <button className="btn rota-primary-button" onClick={onSubmit}>Buscar</button>
      </div>

      <div className="row">
        <div className="col-md-3 mb-3">
          <label className="rota-label">Período inicial</label>
          <input type="date" className="form-control rota-input" name="inicial" value={filters.inicial} onChange={onChange} />
        </div>
        <div className="col-md-3 mb-3">
          <label className="rota-label">Período final</label>
          <input type="date" className="form-control rota-input" name="final" value={filters.final} onChange={onChange} />
        </div>
        <div className="col-md-3 mb-3">
          <label className="rota-label">Fiscal</label>
          <select className="custom-select rota-input" name="fiscal" value={filters.fiscal} onChange={onChange}>
            <option value="Todos">Todos</option>
            {fiscals.map((fiscal) => <option key={fiscal._id || fiscal.nome} value={fiscal.nome}>{fiscal.nome}</option>)}
          </select>
        </div>
        <div className="col-md-3 mb-3">
          <label className="rota-label">Estado</label>
          <select className="custom-select rota-input" name="estado" value={filters.estado} onChange={onChange}>
            <option value="todos">Todos</option>
            {ESTADOS.map((estado) => <option key={estado.value} value={estado.value}>{estado.value}</option>)}
          </select>
        </div>
        <div className="col-md-3 mb-3">
          <label className="rota-label">Situação</label>
          <select className="custom-select rota-input" name="situacao" value={filters.situacao} onChange={onChange}>
            <option value="todas">Todas</option>
            <option value="aprovada">Aprovada</option>
            <option value="reprovada">Reprovada</option>
          </select>
        </div>
        <div className="col-md-3 mb-3">
          <label className="rota-label">Realizada</label>
          <select className="custom-select rota-input" name="realizada" value={filters.realizada} onChange={onChange}>
            <option value="todas">Todas</option>
            <option value="realizada">Realizada</option>
            <option value="nao-realizada">Não realizada</option>
          </select>
        </div>
      </div>
    </div>
  )
}
